<template>
  <el-cascader
    :modelValue="modelValue"
    :placeholder="'请选择'"
    :disabled="disabled"
    separator="-"
    :props="props"
    :options="areaOptions || []"
    collapse-tags
    @change="handleChange"
    v-bind="$attrs"
  ></el-cascader>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { computed, onMounted, useCurrentAppInstance } from '@zto/zpage'
import { getAreasRef, loadAreas } from '../../utils/areaAll'

const newProps = withDefaults(
  defineProps<{
    modelValue: Array<any>
    props: Record<string, any>
    disabled: boolean
  }>(),
  {
    disabled: false
  }
)
const emit = defineEmits(['update:modelValue'])

const app = useCurrentAppInstance()

const areaOptions = computed(() => getAreasRef().value)

onMounted(async () => {
  await loadAreas(app)
})

// 修改时触发
function handleChange(vals: any) {
  let valsData = vals || [],
    resultList: any = []
  valsData.forEach((it: any, idx: number) => {
    if (newProps.props?.multiple) {
      it.forEach((el: any, idx0: number) => {
        if (idx0 == it.length - 1) {
          resultList.push(el)
        }
      })
    } else {
      if (idx == valsData.length - 1) {
        resultList.push(it)
      }
    }
  })

  emit('update:modelValue', resultList)
  return resultList
}
</script>
